import { ToastMessage } from 'constants/toastMessage';
import { toast } from 'react-toastify';

export const showToastError = (res) => {
  if (!res?.data) {
    toast.error(ToastMessage.SERVER_ERROR);
    return;
  }
  const { errors, message } = res.data;
  if (errors) {
    toast.error(errors.join('\n\n'));
    return;
  }
  if (message) {
    toast.error(message.split('\r\n').join('\n\n'));
    return;
  }
  toast.error(ToastMessage.SERVER_ERROR);
};

export const showToastWarnDownload = (data) => {
  if (!data || data.length === 0) {
    toast.warn('No data to download');
    return true;
  }
  return false;
};
